import toSnakeCase from '@nubank/nuds-web/utils/string/toSnakeCase';

import { sendToGTM } from './gtm';

export function sendEvent(event, payload = {}) {
  const normalizedPayload = Object
    .entries(payload)
    .reduce((aggr, [key, value]) => ({
      ...aggr,
      [toSnakeCase(key)]: value,
    }), {});

  const dataLayerEvent = {
    event,
    payload: normalizedPayload,
  };

  sendToGTM(dataLayerEvent);
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export function sendPageView(pagePath) {
  const pageView = {
    page_path: pagePath,
  };

  sendToGTM(pageView);
}

export function sendRegisterProspectEvent(prospectTypeChannel, marketingId) {
  const payload = {
    prospectType: prospectTypeChannel,
  };

  if (marketingId) {
    payload.marketingId = marketingId;
  }

  sendEvent('REGISTER_PROSPECT', payload);
}
